// @flow
import * as React from "react"
import { Circle, StyledText as Text, Wrapper } from "./styled"

type Props = {
  children: React.Node,
  minimal?: boolean,
}

const Bulletpoint = ({ children, minimal = false }: Props) => {
  return (
    <Wrapper>
      <Circle />
      <Text minimal>
        {children}
      </Text>
    </Wrapper>
  )
}

export default Bulletpoint



// WEBPACK FOOTER //
// ./src/components/Bulletpoint/index.js